let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1YAwp")).then(() => parcelRequire('3ZrPs'));